"use client";

import React from "react";
import { Button } from "../common/button";

export interface FinalCTAProps {
  title: string;
  subtitle?: string;
  ctaText: string;
  onCtaClick?: () => void;
  bgColor?: string;
  showArrow?: boolean;
}

export function FinalCTA({
  title,
  subtitle,
  ctaText,
  onCtaClick,
  bgColor = "bg-white",
  showArrow = true
}: FinalCTAProps) {
  return (
    <section className={`py-16 ${bgColor}`}>
      <div className="max-w-3xl mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          {title}
        </h2>
        {subtitle && (
          <p className="text-lg text-gray-600 mb-8">
            {subtitle}
          </p>
        )}
        <Button size="lg" onClick={onCtaClick}>
          {ctaText}
          {showArrow && (
            <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          )}
        </Button>
      </div>
    </section>
  );
}